export default function DocumentsApi({ makeRequest, buildRequest }) {

    function getDocuments() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Documents'));
        });
    }

    function getDocumentsByParentId(parentId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/Documents/ByParent/${parentId}`));
        });
    }

    function getDocumentById(documentId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/Documents/${documentId}`));
        });
    }

    function upsertDocument(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Documents/Upsert', payload));
        });
    }

    function deleteDocument(documentId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Documents/${documentId}`));
        });
    }

    function uploadDocumentFile(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Documents/Upload', payload));
        });
    }

    function initChunkedUpload(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Documents/Upload/Chunked/Init', payload));
        });
    }

    function uploadBlock(uploadId, blockIndex, blockData) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(
                `/api/Documents/Upload/Chunked/${uploadId}/Block/${blockIndex}`,
                blockData,
                {
                    headers: { 'Content-Type': 'application/octet-stream' },
                    timeout: 120000, // 2 min per chunk
                }
            ));
        });
    }

    function commitChunkedUpload(uploadId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`/api/Documents/Upload/Chunked/${uploadId}/Commit`));
        });
    }

    function getDocumentFile(documentId) {
        return buildRequest().then(function (req) {
            return req.get(`/api/Documents/${documentId}/File`, { responseType: 'blob' });
        });
    }

    return {
        getDocuments,
        getDocumentsByParentId,
        getDocumentById,
        upsertDocument,
        deleteDocument,
        uploadDocumentFile,
        initChunkedUpload,
        uploadBlock,
        commitChunkedUpload,
        getDocumentFile,
    };
}
